<template>
  <div class="col-12 text-end" v-if="modelValue">
    <div class="popup_bg"></div>
    <div id="historyModal" class="modal_class">
      <div class="modal-content invoice">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span><b>History for PPPoE ID:</b> <span class="text-success">{{ pppoeId }}</span></span>
          <span class="font-weight-bold">Total {{ totalRecords }} times down</span>
          <span @click="closePopup" class="close">&times;</span>
        </div>
        <div class="my-3">
          <div v-for="(logGroup, index) in historyData" :key="index" class="history-section mb-4">
            <div class="date-header p-2 mb-2">
              <h6 class="mb-0">{{ logGroup.date }} ({{ logGroup.count }} times down)</h6>
            </div>
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Date</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Time</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Action</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">IP</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">MAC</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="(log, logIndex) in logGroup.data" :key="logIndex">
                    <td class="align-middle text-center">{{ formatDate(log.timestamp) }}</td>
                    <td class="align-middle text-center">{{ formatTime(log.timestamp) }}</td>
                    <td class="align-middle text-center">{{ log.action }}</td>
                    <td class="align-middle text-center">{{ log.ip }}</td>
                    <td class="align-middle text-center">{{ log.mac }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryPopup',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    pppoeId: {
      type: String,
      required: true
    },
    historyData: {
      type: Array,
      required: true
    }
  },
  computed: {
    totalRecords() {
      return this.historyData.reduce((acc, group) => acc + (group.count || 0), 0);
    }
  },
  methods: {
    closePopup() {
      this.$emit('update:modelValue', false);
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleDateString();
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleTimeString();
    }
  }
};
</script>

<style scoped>
.popup_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal_class {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #181f2a;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  padding: 24px 24px 16px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: none;
}

.modal_class::-webkit-scrollbar {
  display: none;
}

.close {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-left: 16px;
}

.close:hover {
  color: #aaa;
}

.modal-content {
  max-width: 1000px !important;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #444 transparent;
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.history-section {
  background: #232b3e;
  border-radius: 8px;
  max-height: 400px;
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #444 transparent;
}

.history-section::-webkit-scrollbar {
  width: 6px;
}

.history-section::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}

.history-section::-webkit-scrollbar-track {
  background: transparent;
}

.date-header {
  text-align: start;
  border-bottom: 1px solid #2d3748;
}

.date-header h6 {
  color: #82D616;
  font-weight: 600;
}
</style> 